export default __webpack_public_path__ + "static/media/federico-fellini.5594ba80.jpg";